'use strict';

var angular = require('angular');
var dependencies = ['AVRO.RomSummary.CommonComponents', 'AVRO.Common.ViewportLegend', 'AVRO.Common.DataService'];
module.exports = angular.module('AVRO.RomSummary.TopOpp', dependencies).directive('rmRomSummaryTopOpp', require('./directives/RomSummaryTopOppDirective')).controller('RomSummaryTopOppController', require('./controllers/RomSummaryTopOppController'));